// components/organization/Pagination.jsx
import React from "react";

const Pagination = ({ page, pages, onChange }) => {
  if (!pages || pages <= 1) return null;

  const prev = () => page > 1 && onChange(page - 1);
  const next = () => page < pages && onChange(page + 1);

  // ساخت صفحه‌ها (ساده؛ می‌شه الگوریتم فشرده‌تر هم زد)
  const nums = [];
  for (let i=1; i<=pages; i++) nums.push(i);

  return (
    <div className="flex items-center justify-center gap-2 mt-6">
      <button onClick={prev} disabled={page===1} className="px-3 py-1 border rounded-md disabled:opacity-50">
        قبلی
      </button>
      {nums.map(n=>(
        <button
          key={n}
          onClick={()=>onChange(n)}
          className={`px-3 py-1 border rounded-md ${n===page ? "bg-purple-600 text-white border-purple-600" : ""}`}
        >
          {n}
        </button>
      ))}
      <button onClick={next} disabled={page===pages} className="px-3 py-1 border rounded-md disabled:opacity-50">
        بعدی
      </button>
    </div>
  );
};

export default Pagination;
